import styled from 'styled-components';

export const ScNavigationAccordionItem = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	summary::-webkit-details-marker {
		display: none;
	}
`;

export const ScNavigationAccordionItemTitle = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	color: ${({ theme }) => theme.colors.darkText};
	font: ${({ theme }) => theme.fonts.footer.smallTitle};
	width: 100%;
	height: 22px;
	img {
		width: 22px;
		height: 22px;
	}
	a,
	button {
		color: ${({ theme }) => theme.colors.darkText};
		font: ${({ theme }) => theme.fonts.footer.smallTitle};
		text-decoration: none;
	}
	button {
		background: transparent;
		border: 0;
		padding: 0;
		cursor: pointer;
	}
`;

export const ScNavigationAccordionContent = styled.div`
	margin-top: 15px;
	display: flex;
	flex-direction: column;
	gap: 4px;
	a,
	button {
		text-decoration: none;
		color: ${({ theme }) => theme.colors.darkText};
		font: ${({ theme }) => theme.fonts.footer.smallLink};
		background: transparent;
		border: 0;
		padding: 0;
		text-align: left;
		cursor: pointer;
	}
`;
